import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { Conversation } from '../conversation.js';
import { Exam } from '../exam.js';

export const deleteExamMutation = registerMutation({
  operationName: 'deleteExamMutation',
  type: () => Boolean,
  params: [{ name: 'examId', type: () => String }],
  resolve: (examId: string) => async () => {
    const examCollection = await getCollection(Exam);

    const examToDelete = await examCollection.findOne({ _id: examId });

    if (!examToDelete) {
      throw new Error(`Klausur mit ID ${examId} nicht gefunden.`);
    }

    await examCollection.deleteOne({ _id: examId });

    if (examToDelete.conversationId) {
      const convCollection = await getCollection(Conversation);
      await convCollection.deleteOne({ _id: examToDelete.conversationId });

      logger.info({ conversationId: examToDelete.conversationId, examId }, 'Deleting conversation of deleted exam.');
    }

    return true;
  },
});
